<template>
  <v-card width="480px" class="confirm">
    <div class="confirm__icon" aria-hidden="true"><v-icon>mdi-delete-alert-outline</v-icon></div>
    <p class="confirm__title">{{ title }}</p>
    <div class="confirm__actions">
      <v-btn text large @click="cancel">Anulare</v-btn>
      <v-btn large color="error" depressed @click="confirm">
        <v-icon left>mdi-delete-outline</v-icon>Șterge
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped>
.confirm {
  padding: 26px 26px 20px;
}
.confirm__icon .v-icon {
  font-size: 40px;
  color: var(--brick);
}
.confirm__title {
  margin: 10px 0 22px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.35rem;
  line-height: 1.3;
  color: var(--ink);
}
.confirm__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
